import type { ColumnsType } from "antd/es/table";
import _ from "lodash";
import { Key, useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { dataWrapper } from "../../../redux/actions";
import {
  ClaimDataType,
  ClaimDtlDataType,
  DutyDataType,
} from "../../../types/TableTypes";
import addKey from "../../../utility/addKeys";
import TableWithCollapse from "../../component/TableWithCollapse";
import dayjs from "dayjs";
import {
  Badge,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  List,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import {
  COL_SPAN,
  errorMsg,
  RateType,
  StatusFilters,
  statusProcess,
  StatusWithEle,
  STRING_DATE,
} from "../../../const/constant";
import { ExpandableConfig } from "antd/es/table/interface";
import formatAmount from "../../../utility/formatAmount";
import { LeftOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import CalendatWithLabels from "../../component/CalendarWithLabels";
import { Claim } from "../../../types/RequestTypes";
// import { RootState } from "../../../redux/reducers";

const TextFieldName = {
  true: "Remark",
  false: "Reject Reason",
};

function ApprovalTable(props) {
  const { req_duty_info, device, dataFetch, isApprover, setToStep } = props;
  //state Info for step 2 (Data in Heading)
  const [dutyInfo, setDutyInfo] = useState<{ [key: string]: DutyDataType[] }>();
  //state Info for step 2 (Data in Table)
  const [claimInfo, setClaimInfo] = useState<{
    [key: string]: ClaimDataType[];
  }>();

  //Table States

  //Table Key expand states
  const [expandKeys, setExpandKeys] = useState<React.Key[]>([]);
  //Table Row selected states (changed to whether select as default)
  const [selectedRowKeys, setSelectedRowKeys] = useState<{
    [key: string]: React.Key[];
  }>({});
  //Table Calendar States
  const [showCalendar, setShowCalendar] = useState({
    showModal: false,
    key: "",
  });
  //State for Calendar Types
  const [calendarState, setCalendarState] = useState<{
    [key: string]: Claim[];
  }>({});

  //Store Approval State (used for form submission)
  const [approval, setApprovalState] = useState<{
    [SP_SUP_CLAIM_PK: number]: { APPROVE: boolean };
  }>({});
  // isReadTAC
  const [isReadTAC, setIsReadTAC] = useState<boolean>(false);

  const [totalRequestedHr, setTotalRequestedHr] = useState<number>(0);

  //Type for form submission
  interface FORM_STATE {
    [SP_SUP_CLAIM_PK: number]: { APPROVE: boolean; REMARKS?: string };
  }

  //Ref for all keys in duty
  const duty_keys = useRef<{ [DUTY_PK: number]: React.Key[] }>({});

  // const { reject_duty } = useSelector((state: RootState) => state.data);

  const transformDtlData = useCallback((claims, duty) => {
    let c_r: { [key: string]: ClaimDataType[] } = {};
    for (const [c_key, c_value] of Object.entries<any>(claims)) {
      const cls = _.groupBy(c_value, "BATCH_NO");
      let new_claims: ClaimDataType[] = [];
      for (const [key, value] of Object.entries(cls)) {
        let claim: ClaimDataType;
        let tot_time = 0;
        let amount = 0;
        claim = {
          key: key,
          AMOUNT: "0.00",
          startDate: dayjs(value[0].START_DATE).format(STRING_DATE),
          DATE: `${dayjs(value[0].START_DATE).format(STRING_DATE)} to ${dayjs(
            value[0].END_DATE
          ).format(STRING_DATE)}`,
          STATUS: value[0].STATUS,
          SUBMISSION_DATE: `${dayjs(value[0].CREATION_DATE).format(
            STRING_DATE
          )}`,
          TIME: "",
          SP_DUTY_PK: value[0].SP_DUTY_PK,
          SP_SUP_CLAIM_PK: value[0].SP_SUP_CLAIM_PK,
          BATCH_NO: value[0].BATCH_NO,
          ENDORSER: value[0].ENDORSER,
          APPROVER: value[0].APPROVER,
          CLAIM_DTL: [],
        };
        let i = 0;
        if (duty?.[c_key][0].RATE_TYPE === "H") {
          for (const claim_dtl of value) {
            amount += claim_dtl.CLAIM_AMT;
            tot_time += claim_dtl.HR_CLAIM;
            if (claim_dtl.CLAIM_DATE && claim_dtl.HR_CLAIM) {
              claim.CLAIM_DTL?.push({
                key: `${key}_${i}`,
                DTL_DATE: `${dayjs(claim_dtl.CLAIM_DATE).format(STRING_DATE)}`,
                DTL_TIME: `${claim_dtl.HR_CLAIM} hr(s)`,
              });
            }
            ++i;
          }
          claim.AMOUNT = formatAmount(amount);
          claim.TIME = `${tot_time} hr(s)`;
        } else {
          claim.AMOUNT = formatAmount(value[0].TOT_CLAIM_AMT);
        }
        new_claims.push(claim);
      }
      c_r[c_key] = new_claims;
    }
    return c_r;
  }, []);

  const transformCalendarData = useCallback((claims) => {
    const cs: { [key: string]: Claim[] } = {};
    for (const [c_key, c_value] of Object.entries<any>(claims)) {
      const cls = _.groupBy(c_value, "SP_SUP_CLAIM_PK");
      const claims: Claim[] = [];
      for (const value of Object.values(cls)) {
        let c: Claim;
        c = {
          STATUS: value[0].STATUS,
          SP_SUP_CLAIM_PK: value[0].SP_SUP_CLAIM_PK,
          START_DATE: value[0].START_DATE,
          END_DATE: value[0].END_DATE,
          CLAIMS_DETAILS: [],
          ENDORSER: value[0].ENDORSER,
        };
        for (const claim_dtl of value) {
          c.CLAIMS_DETAILS?.push({
            CLAIM_DATE: claim_dtl.CLAIM_DATE,
            HR_CLAIM: claim_dtl.HR_CLAIM,
          });
        }
        claims.push(c);
      }
      cs[c_key] = claims;
    }
    return cs;
  }, []);

  //Check Duty all checked states
  const dutyRowAllChecked = (duty_key) => {
    const c_ks: React.Key[] = duty_keys.current[duty_key];
    if (!c_ks || !(duty_key in selectedRowKeys)) return false;
    return c_ks.every((c) => selectedRowKeys[duty_key].includes(c));
  };
  //Check All approval status
  const dutyRowAllApproved = (duty_key) => {
    const c_ks: React.Key[] = duty_keys.current[duty_key];
    let all_checked = true;
    let all_unchecked = true;
    if (!c_ks) return "E";
    for (const c of c_ks) {
      if (c in approval) {
        if (approval[c].APPROVE) {
          all_unchecked = false;
        } else {
          all_checked = false;
        }
      } else {
        return "E";
      }
    }
    if (all_checked) return "true";
    if (all_unchecked) return "false";
    return "E";
  };

  // TODO - Check All Row Checked
  // const isAllRowChecked = () => {
  //   let allDuty: Key[] = [];
  //   for (const key in duty_keys.current) {
  //     duty_keys.current[key].forEach((batchNumber) => {
  //       allDuty.push(batchNumber);
  //     });
  //   }

  //   let selected: Key[] = [];
  //   for (const key in selectedRowKeys) {
  //     duty_keys.current[key].forEach((batchNumber) => {
  //       selected.push(batchNumber);
  //     });
  //   }

  //   const res1 = allDuty.filter((key) => !selected.includes(key));
  //   const res2 = selected.filter((key) => !allDuty.includes(key));

  //   if (
  //     allDuty.length &&
  //     selected.length &&
  //     allDuty.length === selected.length &&
  //     res1.length === 0 &&
  //     res2.length === 0
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // const isAllRowApproved = () => {
  //   const allChecked = isAllRowChecked();
  // };

  useEffect(() => {
    if (req_duty_info) {
      const duty_g_claim = _.groupBy(req_duty_info.claim_dtl, "SP_DUTY_PK");
      const duty_info = _.groupBy(req_duty_info.duty_info, "SP_DUTY_PK");
      //Set Map By Duty
      for (const [key_duty, value] of Object.entries(duty_g_claim)) {
        const claim_l = _.groupBy(value, "BATCH_NO");
        duty_keys.current[key_duty] = [];
        for (const key_claim of Object.keys(claim_l)) {
          duty_keys.current[key_duty].push(key_claim);
        }
      }
      setDutyInfo(addKey(duty_info));
      setClaimInfo(addKey(transformDtlData(duty_g_claim, duty_info)));
      setCalendarState(transformCalendarData(duty_g_claim));

      let sumTotalReqHr = 0;
      req_duty_info.claim_dtl.forEach((claim: any) => {
        if (claim.HR_CLAIM && parseFloat(claim.HR_CLAIM)) {
          sumTotalReqHr = sumTotalReqHr + parseFloat(claim.HR_CLAIM);
        }
      });
      if (sumTotalReqHr > 0) {
        setTotalRequestedHr(sumTotalReqHr);
      }
    }
  }, [req_duty_info, transformDtlData, transformCalendarData]);

  useEffect(() => {
    // console.log("*****approval:", approval);
    const newExpandKeys: React.Key[] = [];
    for (const key in approval) {
      if (approval[key].APPROVE === false) {
        newExpandKeys.push(key);
      }
    }

    setExpandKeys(newExpandKeys);
  }, [approval]);

  const selectAll = () => {
    const newSelectedRowKeys = { ...duty_keys.current };
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const removeAll = () => {
    let newSelectedRowKeys = { ...duty_keys.current };
    for (const key in newSelectedRowKeys) {
      newSelectedRowKeys[key] = [];
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const RenderBadge = (record) => {
    let newStatus = statusProcess(record);
    return (
      <Badge
        style={{ display: "flex", alignItems: "center" }}
        {...StatusWithEle[newStatus]}
      />
    );
  };

  const handleSelectChange =
    (duty_key: number, claim_key: React.Key) => (value: string) => {
      switch (value) {
        case "default":
          setSelectedRowKeys((k) => {
            const new_k = { ...k };
            new_k[duty_key] = new_k[duty_key].filter((x) => x !== claim_key);
            return new_k;
          });
          setApprovalState((k) => {
            const new_k = { ...k };
            delete new_k[claim_key];
            return new_k;
          });
          break;
        default:
          setSelectedRowKeys((k) => {
            const new_k = { ...k };
            if (!(duty_key in new_k)) {
              new_k[duty_key] = [];
            }
            if (!new_k[duty_key].includes(claim_key))
              new_k[duty_key].push(claim_key);
            return new_k;
          });
          setApprovalState((k) => {
            const new_k = { ...k };
            new_k[claim_key] = { APPROVE: value === "true" ? true : false };
            return new_k;
          });
          break;
      }
    };

  const getValueFromKeys = (duty_key: number, claim_key: React.Key) => {
    if (
      duty_key in selectedRowKeys &&
      selectedRowKeys[duty_key].includes(claim_key) &&
      claim_key in approval
    ) {
      //Return true or false
      if (approval[claim_key].APPROVE) return "true";
      return "false";
    }
    return "default";
  };

  const duty_columns: ColumnsType<ClaimDataType> = [
    { title: "Date", dataIndex: "DATE", key: "DATE" },
    { title: "Time / Hours", dataIndex: "TIME", key: "TIME" },
    { title: "Amount", dataIndex: "AMOUNT", key: "AMOUNT" },
    {
      title: "Status",
      key: "STATUS",
      render: (text, record, index) => RenderBadge(record),
      responsive: ["md"],
      ...StatusFilters,
    },
    {
      title: "Staff Submission Date",
      dataIndex: "SUBMISSION_DATE",
      key: "SUBMISSION_DATE",
      responsive: ["md"],
    },
    {
      title: isApprover ? "Approval" : "Endorsement",
      key: `APPROVAL`,
      render: (text, record, index) => {
        //If state does not exist, do not return div
        if (record.SP_DUTY_PK) {
          return (
            <Select
              value={getValueFromKeys(record.SP_DUTY_PK, record.key)}
              style={{ width: 120 }}
              onChange={handleSelectChange(record.SP_DUTY_PK, record.key)}
              options={[
                { value: "true", label: isApprover ? "Approve" : "Endorse" },
                { value: "false", label: "Reject" },
                { value: "default", label: "Select" },
              ]}
            />
          );
        }
        return <></>;
      },
    },
  ];

  const dutyShowOnTable = {
    TIME: { desktop: false, tablet: false, mobile: false },
    DATE: { desktop: false, tablet: false, mobile: false },
    AMOUNT: { desktop: false, tablet: false, mobile: false },
    STATUS: { desktop: false, tablet: false, mobile: true },
    SUBMISSION_DATE: { desktop: false, tablet: false, mobile: true },
    BATCH_NO: { desktop: true, tablet: true, mobile: true },
    APPROVER: { desktop: true, tablet: true, mobile: true },
    ENDORSER: { desktop: true, tablet: true, mobile: true },
  };

  const dutyTitle = {
    TIME: "Time",
    DATE: "Date",
    AMOUNT: "Amount",
    STATUS: "Status",
    SUBMISSION_DATE: "Staff Submission Date",
    BATCH_NO: "Batch Reference",
    APPROVER: "Approver",
    ENDORSER: "Endorser",
  };

  const isSearchTable = {
    DATE: true,
    TIME: true,
    AMOUNT: true,
    STATUS: false,
    SUBMISSION_DATE: true,
  };

  const duty_expandable: ExpandableConfig<ClaimDataType> = {
    expandedRowRender: (record) => {
      const col: JSX.Element[] = [];
      for (const [key, value] of Object.entries(record)) {
        let valueCol = (
          <Col key={`${key}_size`} span={18}>
            {value}
          </Col>
        );
        if (key === "STATUS") {
          valueCol = (
            <Col key={`${key}_size`} span={18}>
              {RenderBadge(record)}
            </Col>
          );
        }
        if (dutyShowOnTable?.[key]?.[device.size] === true && value) {
          col.push(
            <Row key={key}>
              <Col span={6}>{`${dutyTitle[key]} :`}</Col>
              {valueCol}
            </Row>
          );
        }
      }
      let claimDtlByOrder: ClaimDtlDataType[] = [];
      if (record.CLAIM_DTL && record.CLAIM_DTL.length > 0) {
        claimDtlByOrder = record.CLAIM_DTL.sort(
          (a: ClaimDtlDataType, b: ClaimDtlDataType) => {
            const dtlDateA = dayjs(a.DTL_DATE);
            const dtlDateB = dayjs(b.DTL_DATE);
            if (dtlDateA < dtlDateB) {
              return -1;
            } else if (dtlDateA > dtlDateB) {
              return 1;
            } else {
              return 1;
            }
          }
        );
      }
      return (
        <div>
          {col.length > 0 && (
            <div>
              <div style={{ padding: "8px 0" }}>{col}</div>{" "}
              <Divider style={{ margin: "1rem 0 0 0" }} />
            </div>
          )}
          {claimDtlByOrder.length > 0 && (
            <List
              dataSource={claimDtlByOrder}
              renderItem={(item) => (
                <List.Item style={{ padding: "1rem 0" }}>
                  <Row style={{ width: "100%" }}>
                    <Col span={6}>Date :</Col>{" "}
                    <Col span={18}>{item.DTL_DATE}</Col>
                    <Col span={6}>Time :</Col>{" "}
                    <Col span={18}>{item.DTL_TIME}</Col>
                  </Row>
                </List.Item>
              )}
            />
          )}
          {record.key in approval && (
            <Form.Item
              style={{ marginTop: "1rem" }}
              label={TextFieldName[approval[record.key].APPROVE]}
              name={`${record.key}_REASON`}
              rules={[
                {
                  required: !approval[record.key].APPROVE,
                  message: "Please input your reject reason.",
                },
              ]}
            >
              <TextArea
                rows={4}
                maxLength={500}
                placeholder={`Please Enter Your ${
                  TextFieldName[approval[record.key].APPROVE]
                } Here`}
              />
            </Form.Item>
          )}
        </div>
      );
    },
    rowExpandable: (record) => {
      let showCol = false;
      for (const [key, value] of Object.entries(record)) {
        if (dutyShowOnTable?.[key]?.[device.size] === true && value) {
          showCol = true;
        }
      }
      showCol =
        showCol || (record.CLAIM_DTL ? record.CLAIM_DTL.length > 0 : false);
      return showCol;
    },
    onExpand: (expanded, record) => {
      let keys = expandKeys;
      if (expanded && !keys.includes(record.key)) {
        keys.push(record.key);
      } else if (!expanded && keys.includes(record.key)) {
        keys = keys.filter((i) => i !== record.key);
      }
      setExpandKeys(keys);
    },
    expandedRowKeys: expandKeys,
  };

  const setAllApproval = (action: "approve" | "reject" | "default") => {
    let allKey: Key[] = [];
    const newApprovalState = { ...approval };

    for (const key in duty_keys.current) {
      duty_keys.current[key].forEach((batchNumber) => {
        allKey.push(batchNumber);
      });
    }
    allKey.forEach((key) => {
      switch (action) {
        case "approve":
          newApprovalState[key] = { APPROVE: true };
          break;
        case "reject":
          newApprovalState[key] = { ...newApprovalState[key], APPROVE: false };
          break;
        case "default":
          delete newApprovalState[key];
      }
    });
    setApprovalState(newApprovalState);

    if (action !== "default") {
      selectAll();
    } else {
      removeAll();
    }
  };

  const onFinish = async (value) => {
    const sub_app: FORM_STATE = { ...approval };
    // console.log("*****approval:", approval);

    //APPEND DUTY RESULT TO ALL CLAIMS
    for (const [k_value, v_value] of Object.entries<any>(value)) {
      const k_arr = k_value.split("_");
      // [0] : PK for key
      // [1] : Code for key
      if (v_value) {
        switch (k_arr[1]) {
          case "DUTYREASON":
            for (const cl of duty_keys.current[k_arr[0]]) {
              if (cl in sub_app) {
                sub_app[cl] = { ...sub_app[cl], REMARKS: v_value };
              }
            }
            break;
          case "REASON":
            sub_app[k_arr[0]] = { ...sub_app[k_arr[0]], REMARKS: v_value };
            break;
        }
      }
    }

    const submit_json = {
      APPROVER_STAFF_NO: req_duty_info.APPROVER_STAFF_NO,
      CLAIMS: sub_app,
      ACTION: isApprover ? "APPROVE" : "ENDORSE",
    };
    // console.log("*****submit_json:", submit_json);

    const response = await dataFetch(
      "ptps/approveRequest",
      { value: submit_json },
      "POST"
    );
    if (response?.result === "0") {
      message.success("Submission Completed");
      //FETCH AND NAVIGATE
      setToStep(-1);
    } else {
      errorMsg(response?.error);
    }
  };

  const onSubmitClick = () => {
    if (duty_keys.current) {
      const newE = [...expandKeys];
      const current = duty_keys.current;
      for (const keyDuty in current) {
        if (dutyRowAllApproved(keyDuty) !== "E" && dutyRowAllChecked(keyDuty)) {
          continue;
        }
        for (const key_claim of current[keyDuty]) {
          if (approval?.[key_claim]?.APPROVE === false) {
            //Expand Row Here
            if (!newE.includes(key_claim)) {
              newE.push(key_claim);
            }
            // errorMsg(
            //   "Please input the rejection reason for each rejected payment request."
            // );
          }
        }
      }
      setExpandKeys(newE);
    }
  };

  const dutyMap =
    duty_keys.current &&
    Object.keys(duty_keys.current)?.map((id) => {
      // const app = dutyRowAllApproved(id);
      // const checked = dutyRowAllChecked(id);

      // let rejectCountObj: any = null;
      // // @ts-ignore
      // if (dutyInfo && reject_duty && reject_duty?.length) {
      //   // @ts-ignore
      //   rejectCountObj = reject_duty.find(
      //     (x) => x.SP_DUTY_PK === dutyInfo[id][0].SP_DUTY_PK
      //   );
      // }
      // let totalRejectAmt: number = 0;
      // if (rejectCountObj) {
      //   totalRejectAmt = rejectCountObj.TOT_REJECT_AMT;
      // }

      return (
        <div
          key={id}
          style={{
            padding: "10px",
            // borderBottom: "2px solid Black",
            marginBottom: 15,
          }}
        >
          {dutyInfo && (
            <Row
              gutter={[0, { xs: 8, sm: 8, md: 12, lg: 16 }]}
              style={{ marginBottom: "1rem" }}
            >
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][0]}
              >
                Post Title:
              </Col>{" "}
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][1]}
              >
                {dutyInfo[id][0].POST_TITLE}
              </Col>
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][0]}
              >
                Prog/Proj Title:
              </Col>{" "}
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][1]}
              >
                {dutyInfo[id][0].PROG_PROJ_TITLE}
              </Col>
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][0]}
              >
                Prog/Proj Code:
              </Col>{" "}
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][1]}
              >
                {dutyInfo[id][0].PROG_PROJ_CODE}
              </Col>
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][0]}
              >
                Duty:{" "}
              </Col>{" "}
              <Col
                style={{ fontWeight: "bold" }}
                span={COL_SPAN[device.size][1]}
              >
                {dutyInfo[id][0].DT_DESC}
              </Col>
              <Col span={COL_SPAN[device.size][0]}>Rate Type: </Col>{" "}
              <Col span={COL_SPAN[device.size][1]}>
                {RateType[dutyInfo[id][0].RATE_TYPE]}
              </Col>
              {dutyInfo[id][0].RATE_TYPE === "L" && (
                <>
                  <Col span={COL_SPAN[device.size][0]}>Lump Sum:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {formatAmount(dutyInfo[id][0].LUMP_SUM)}
                  </Col>
                  <Col span={COL_SPAN[device.size][0]}>Remaining:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {formatAmount(
                      dutyInfo[id][0].LUMP_SUM - dutyInfo[id][0].LUMP_SUM_PAID
                    )}
                  </Col>
                </>
              )}
              {dutyInfo[id][0].RATE_TYPE === "H" && (
                <>
                  <Col span={COL_SPAN[device.size][0]}>Hourly Rate:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {formatAmount(dutyInfo[id][0].HR_RATE)}
                  </Col>
                  <Col span={COL_SPAN[device.size][0]}>Remaining:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {formatAmount(
                      dutyInfo[id][0].HR_MAX - dutyInfo[id][0].HR_PAID,
                      false
                    )}{" "}
                    hr(s)
                  </Col>
                  <Col span={COL_SPAN[device.size][0]}>Max Hours:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {dutyInfo[id][0].HR_MAX} hr(s)
                  </Col>
                </>
              )}
              {dutyInfo[id][0].RATE_TYPE === "M" && (
                <>
                  <Col span={COL_SPAN[device.size][0]}>Monthly Rate:</Col>{" "}
                  <Col span={COL_SPAN[device.size][1]}>
                    {formatAmount(dutyInfo[id][0].MONTHLY_RATE)}
                  </Col>
                </>
              )}
              <Col span={24}>
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => setShowCalendar({ key: id, showModal: true })}
                >
                  Show Calendar
                </Button>
              </Col>
            </Row>
          )}
          <TableWithCollapse
            data={claimInfo?.[id]}
            columns={duty_columns}
            expandable={duty_expandable}
            isSearchTable={isSearchTable}
            hideCol={["TIME"]}
          />
          {/* {checked && app !== "E" && (
            <Form.Item
              label={TextFieldName[app]}
              name={`${id}_DUTYREASON`}
              rules={[
                {
                  required: app === "false",
                  message: "Please input your reject reason.",
                },
              ]}
            >
              <TextArea
                rows={4}
                maxLength={500}
                placeholder={`Please Enter Your ${TextFieldName[app]} Here`}
              />
            </Form.Item>
          )} */}
          {/* <Row gutter={[16, 16]} style={{ marginBottom: "1rem" }}>
            <Col>
              <Button
                onClick={() => {
                  setAllApproval("approve");
                }}
                htmlType="button"
              >
                {isApprover ? "Approve All" : "Endorse All"}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => {
                  setAllApproval("reject");
                }}
                htmlType="button"
              >
                Reject All
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => {
                  setAllApproval("default");
                }}
                htmlType="button"
              >
                Clear All
              </Button>
            </Col>
          </Row> */}
          <Divider style={{ borderBottom: "3px solid Black" }} />
        </div>
      );
    });

  // TODO - one textbox
  // const allApproved = isAllRowApproved();
  // console.log("*****allApproved:", allApproved);
  // const allChecked = isAllRowChecked();
  // console.log("*****allChecked:", allChecked);

  return (
    <>
      <Modal
        title="Calendar"
        open={showCalendar.showModal}
        onCancel={() =>
          setShowCalendar((c) => {
            return { ...c, showModal: false };
          })
        }
        width={"initial"}
        style={{ padding: "2rem 1rem", top: 0, maxWidth: "1500px" }}
        footer={null}
      >
        {dutyInfo && showCalendar.key !== "" && (
          <CalendatWithLabels
            claims={calendarState?.[showCalendar.key]}
            validRange={[
              dayjs(dutyInfo?.[showCalendar.key][0]?.START_DATE),
              dayjs(dutyInfo?.[showCalendar.key][0]?.END_DATE).isSame(dayjs(), "month") || dayjs(dutyInfo?.[showCalendar.key][0]?.END_DATE).isAfter(dayjs(), "month") ? 
                dayjs(dutyInfo?.[showCalendar.key][0]?.END_DATE).add(1, "day") : 
                dayjs(dutyInfo?.[showCalendar.key][0]?.END_DATE),
            ]}
            hasInput={false}
            rateType={dutyInfo?.[showCalendar.key][0]?.RATE_TYPE}
            isApprover={isApprover}
            isEndorser={!isApprover}
          />
        )}
      </Modal>
      <Button
        type="text"
        shape="circle"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        icon={<LeftOutlined />}
        onClick={(event) => setToStep(0)}
      ></Button>
      <div style={{ padding: "1rem 0" }}>
        {req_duty_info && (
          <Row
            gutter={[0, { xs: 8, sm: 8, md: 12, lg: 16 }]}
            style={{ fontWeight: "bold" }}
          >
            <Col span={COL_SPAN[device.size][0]}>Staff Name:</Col>{" "}
            <Col span={COL_SPAN[device.size][1]}>
              {req_duty_info.STAFF_NAME}
            </Col>
            <Col span={COL_SPAN[device.size][0]}>Staff No:</Col>{" "}
            <Col span={COL_SPAN[device.size][1]}>{req_duty_info.STAFF_NO}</Col>
            <Col span={COL_SPAN[device.size][0]}>
              Total Requested Amount:
            </Col>{" "}
            <Col span={COL_SPAN[device.size][1]}>
              {formatAmount(req_duty_info.AMOUNT)}
            </Col>
            <Col span={COL_SPAN[device.size][0]}>Total Requested Hour(s):</Col>{" "}
            {totalRequestedHr > 0 && (
              <Col span={COL_SPAN[device.size][1]}>
                {formatAmount(totalRequestedHr, false)} hr(s)
              </Col>
            )}
          </Row>
        )}
        <Divider />
      </div>
      <Form onFinish={onFinish} scrollToFirstError={true}>
        {dutyMap}
        {/* {checked && app !== "E" && (
            <Form.Item
              label={TextFieldName[app]}
              name={`${id}_DUTYREASON`}
              rules={[
                {
                  required: app === "false",
                  message: "Please input your reject reason.",
                },
              ]}
            >
              <TextArea
                rows={4}
                maxLength={500}
                placeholder={`Please Enter Your ${TextFieldName[app]} Here`}
              />
            </Form.Item>
          )} */}
        <Row gutter={[16, 16]} style={{ marginBottom: "1rem" }}>
          <Col>
            <Button
              onClick={() => {
                setAllApproval("approve");
              }}
              htmlType="button"
            >
              {isApprover ? "Approve All" : "Endorse All"}
            </Button>
          </Col>
          {/* <Col>
            <Button
              onClick={() => {
                setAllApproval("reject");
              }}
              htmlType="button"
            >
              Reject All
            </Button>
          </Col> */}
          <Col>
            <Button
              onClick={() => {
                setAllApproval("default");
              }}
              htmlType="button"
            >
              Clear All
            </Button>
          </Col>
        </Row>
        <div>
          <Checkbox
            checked={isReadTAC}
            onChange={(e) => setIsReadTAC(e.target.checked)}
          >
            By clicking "Submit", it implies you have read & agreed with the
            terms and conditions including those governing conflict of interest
            as listed under{" "}
            <a
              href={`${window.location.origin}/ptps/importantNotesPage`}
              target="_blank"
              rel="noreferrer noopener"
            >
              Important Notes
            </a>
          </Checkbox>
        </div>
        <div style={{ width: "100%", display: "flex", marginTop: "15px" }}>
          <Button
            style={{ marginRight: "16px" }}
            type="primary"
            htmlType="submit"
            onClick={() => {
              onSubmitClick();
            }}
            disabled={!isReadTAC}
          >
            Submit
          </Button>
          <Button type="primary" htmlType="submit" onClick={() => setToStep(0)}>
            Cancel
          </Button>
        </div>
      </Form>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    device: state.session.device,
    //req_duty_info: state.data?.req_duty_info
  };
};

const mapDispatchToProps = (dispatch) => ({
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalTable);
